import { AiOutlineStar, AiFillStar } from "react-icons/ai";
/**
 * this component returns a <span> with filled and unfilled stars
 * @param {number} qntStars - the amount of filled stars.
 * @param {*} qntMaxStars  - the amount of maximum stars that can be filled.
 * @returns JSX.Element
 */
export function getStars(qntStars, qntMaxStars) {
  let starsFilled = [];
  for (let i = 0; i < qntStars; i++) {
    starsFilled.push(<AiFillStar size={14} color="#fdd835" key={i} />);
  }

  let qntStarsUnfilled = qntMaxStars - qntStars;

  let starsUnfilled = [];
  for (let i = 0; i < qntStarsUnfilled; i++) {
    starsUnfilled.push(<AiOutlineStar size={14} color="gray" key={i} />);
  }

  return (
    <span>
      {starsFilled.map((star) => {
        return star;
      })}
      <span className="tx-bold">
        {starsUnfilled.map((star) => {
          return star;
        })}
      </span>
    </span>
  );
}
